import React from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { Form, Button, ButtonToolbar } from 'rsuite';
import { MdCheckCircle } from 'react-icons/md';
import { Field } from './common/Field'
import AuthLayout, { authCardClass, focusFirstError } from './common/AuthLayout';
import { Validator } from "@rsuite/validation";

const apiUrl = process.env.REACT_APP_SERVER_API_URL;

const model = Validator.SchemaModel({
    email: "required|email"
});

const ForgotPassword = () => {
    const location = useLocation();
    const [formValue, setFormValue] = React.useState({
        email: location.state?.email || ''
    });
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [sentTo, setSentTo] = React.useState(null);
    const [serverError, setServerError] = React.useState(null);


    const formRef = React.useRef();

    const reset = () => {
        if (!formRef.current.check()) {
            focusFirstError();
            return;
        }

        setIsSubmitting(true);
        setServerError(null);
        const user = { email: formValue.email };
        axios.post(`${apiUrl}/users/forgotPassword`, user)
            .then(() => {
                setSentTo(formValue.email);
            })
            .catch((error) => {
                setServerError(error.response?.data?.msg || 'Something went wrong. Please try again.');
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            reset();
        }
    }


    return (

        <AuthLayout>
            {sentTo ? (
                <div className={authCardClass('compact') + ' text-center'}>
                    <MdCheckCircle className="mx-auto text-green-500 mb-3" size={48} />
                    <h1 className="text-xl font-bold text-gray-900 mb-2">Check your email</h1>
                    <p className="text-sm text-gray-600 mb-5">
                        If an account exists for {sentTo}, we've sent a reset link. It may take a few minutes to arrive.
                    </p>
                    <Link to="../login" className="no-underline">
                        <Button appearance="primary" block>Back to login</Button>
                    </Link>
                </div>
            ) : (
                <Form
                    ref={formRef}
                    onChange={setFormValue}
                    formValue={formValue}
                    model={model}
                    className={authCardClass('compact') + ' auth-form'}
                    size="full"
                    onKeyDown={handleKeyDown}
                >

                    <h1 className="text-xl font-bold text-gray-900 mb-1">Forgot your password?</h1>
                    <p className="text-sm text-gray-600 mb-4">
                        Enter the email you registered with and we'll send you a link to reset your password.
                    </p>

                    <Field
                        name="email"
                        label="Email"
                        autoFocus
                        type="email"
                        autoComplete="email"
                    />
                    {serverError && (
                        <p className="text-sm text-red-600 -mt-3 mb-3" role="alert">{serverError}</p>
                    )}


                    <ButtonToolbar>
                        <Button
                            appearance="primary"
                            onClick={reset}
                            block
                            loading={isSubmitting}
                            disabled={isSubmitting}
                        >
                            Send reset link
                        </Button>
                        <Link to="../login"
                        className="mt-3 block w-full no-underline text-blue-600 hover:text-blue-800 text-sm text-center"
                        >Back to Login</Link>
                    </ButtonToolbar>

                </Form>
            )}
        </AuthLayout>
    )
}

export default ForgotPassword;
